import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromKey = (k) => (k ? new Date(`${k}T00:00:00`) : undefined);

export const ExpiryPicker = ({ value, onChange }) => (
  <Popover>
    <div className="flex gap-2">
      <PopoverTrigger asChild>
        <button type="button" className="flex-1 h-9 px-3 rounded-md border border-input bg-transparent text-left text-sm inline-flex items-center gap-2 text-slate-300 hover:border-amber-500/40" data-testid="promo-form-expiry">
          <CalendarDays className="w-4 h-4 text-slate-500" />
          {value ? fromKey(value).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : <span className="text-slate-500">No expiry</span>}
        </button>
      </PopoverTrigger>
      {value && <button type="button" onClick={() => onChange("")} className="h-9 px-2 text-slate-500 hover:text-rose-300" data-testid="promo-form-expiry-clear"><X className="w-4 h-4" /></button>}
    </div>
    <PopoverContent className="w-auto p-0 bg-panel border-line" align="start">
      <Calendar mode="single" selected={fromKey(value)} onSelect={(d) => onChange(d ? toKey(d) : "")}
        disabled={{ before: new Date() }} initialFocus data-testid="promo-form-expiry-calendar" />
    </PopoverContent>
  </Popover>
);
